import React from "react";
import { RouteProps } from "react-router";
import { Route, Redirect } from "react-router-dom";
import { Routes } from "../constants";
import { useHasToken } from "./utils";

const PrivateRoute = ({ component, ...routerProps }: RouteProps) => {
  const hasToken = useHasToken();
  const Component = component as React.ElementType;
  
  return (
    <Route
      {...routerProps}
      render={(props) =>
        hasToken ? (
          hasToken?.email_verified ? (
            <Component {...props} />
          ) : (
            <Redirect to={Routes.VERIFY_EMAIL} />
          )
        ) : (
          <Redirect to={Routes.LOGIN} />
        )
      }
    />
  );
};

export default PrivateRoute;
